import { render } from "./ViewDocumentClickSignComponent.vue?vue&type=template&id=04877b26&scoped=true"
import script from "./ViewDocumentClickSignComponent.vue?vue&type=script&lang=js"
export * from "./ViewDocumentClickSignComponent.vue?vue&type=script&lang=js"

import "./ViewDocumentClickSignComponent.vue?vue&type=style&index=0&id=04877b26&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04877b26"]])

export default __exports__